// What `admin/curation/hidden` says about a course, keyed by course id. A course that is not in
// the map is one a visitor is shown. The flags are independent -- any combination is legal -- so
// they are read one by one rather than collapsed into a single "hidden".

export const isHidden = (visibility, id) => {
  const flags = visibility && visibility[id]
  if (!flags) return false
  return (
    flags.active === false ||
    flags.private === true ||
    flags.hasVisibleLayouts === false
  )
}

export const hiddenReasons = (visibility, id) => {
  const flags = visibility && visibility[id]
  if (!flags) return []
  return [
    flags.active === false && 'hidden',
    flags.private === true && 'private',
    flags.hasVisibleLayouts === false && 'no visible layouts',
  ].filter(Boolean)
}
